import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7270e9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Parámetros del agua ")
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "text-wrap" }
const _hoisted_4 = { class: "text-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-break" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sampling_point_image_component = _resolveComponent("sampling-point-image-component")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_sampling_point_image_modal_component = _resolveComponent("sampling-point-image-modal-component")!
  const _component_modal_info_estimations_yesterday = _resolveComponent("modal-info-estimations-yesterday")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "real-time card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "img-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 10 }, {
              default: _withCtx(() => [
                (_ctx.image)
                  ? (_openBlock(), _createBlock(_component_sampling_point_image_component, {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.seeImages())),
                      onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.childLoading = true)),
                      onLoaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.childLoading = false)),
                      images: 
            _ctx.image
              ? [
                  {
                    ..._ctx.image,
                    ...{ title: _ctx.isAppDemo ? _ctx.samplingPoint?.id : _ctx.samplingPoint?.name },
                  },
                ]
              : []
          ,
                      class: "vertical-center",
                      "params-visible": _ctx.paramsVisible
                    }, null, 8, ["images", "params-visible"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "header-card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "header-text",
                      style: _normalizeStyle({
              cursor: !_ctx.childLoading ? 'pointer' : 'not-allowed',
              opacity: !_ctx.childLoading && !_ctx.toggleLock ? 1 : 0.5,
            })
                    }, [
                      _createVNode(_component_el_tooltip, {
                        content: 
                _ctx.childLoading
                  ? 'Cargando...'
                  : _ctx.paramsVisible
                  ? 'Ocultar parámetros'
                  : 'Mostrar parámetros'
              ,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.childLoading)
                            ? (_openBlock(), _createElementBlock("em", {
                                key: 0,
                                class: _normalizeClass(["el-icon", _ctx.paramsVisible ? 'el-icon-eye fas' : 'el-icon-eye-slash fas']),
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args))),
                                style: _normalizeStyle({
                  cursor: !_ctx.childLoading ? 'pointer' : 'not-allowed',
                  opacity: !_ctx.childLoading && !_ctx.toggleLock ? 1 : 0.5,
                })
                              }, null, 6))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _hoisted_1
                    ], 4)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.data)
                    ? (_openBlock(), _createBlock(_component_el_table, {
                        key: 0,
                        data: _ctx.orderParameterByName(_ctx.data),
                        ref: "singleTableRef",
                        "row-class-name": _ctx.tableRowClassName,
                        class: "real-time-table",
                        "max-height": "300px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: _ctx.$t('label.name'),
                            "min-width": "165px"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_tooltip, {
                                content: scope.row.parameter.name || '-',
                                placement: "top",
                                disabled: !scope.row.parameter.name
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_el_link, {
                                      onClick: ($event: any) => (_ctx.onClick(scope.row.parameter)),
                                      class: "text-wrap"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(scope.row.parameter.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["content", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            prop: "value",
                            label: "Estimación",
                            "min-width": "120px",
                            align: "center",
                            "header-align": "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_4, [
                                (scope.row.tmoa && scope.row.tmoa !== undefined)
                                  ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(scope.row.tmoa), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (scope.row.parameter?.subtype == 'OPTICAL')
                                    ? (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row.value
                        ? _ctx.getOpticalAndLevelName(scope.row.parameter?.id, scope.row.value)
                        : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_component_el_text, { key: 2 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row.value === undefined
                        ? "-"
                        : isNaN(scope.row.value)
                        ? scope.row.value
                        : _ctx.$n(scope.row.value, "default")), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "parameter.unit",
                            align: "center",
                            label: _ctx.$t('label.units'),
                            width: "85px"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.parameter?.unit ? scope.row.parameter.unit : "-"), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            prop: "trend",
                            align: "center",
                            label: _ctx.$t('label.trend'),
                            width: "140px"
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t("label.trend")) + " ", 1),
                                _createVNode(_component_el_button, {
                                  class: "info",
                                  circle: "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogInfoTrendOpen())),
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx((scope) => [
                              (scope.row.trend !== undefined && scope.row.trend !== null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("info.trend." + scope.row.trend)), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, "-"))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["data", "row-class-name"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.samplingPoint && _ctx.isModalImageVisible && _ctx.image)
      ? (_openBlock(), _createBlock(_component_sampling_point_image_modal_component, {
          key: 0,
          ref: "imageModal",
          title: _ctx.$t('label.imageViewer'),
          id: _ctx.samplingPoint.id,
          onClose: _ctx.closeModalImage,
          "params-visible": _ctx.paramsVisible
        }, null, 8, ["title", "id", "onClose", "params-visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      "custom-class": "app-form",
      modelValue: _ctx.isModalEstimationsYesterdayVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isModalEstimationsYesterdayVisible) = $event)),
      width: "50%",
      height: "400px",
      title: "Información de las estimaciones"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_modal_info_estimations_yesterday, {
          ref: "colourDialog",
          data: _ctx.datosParametros
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogInfoTrendVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogInfoTrendVisible) = $event)),
      title: 'Cálculo de la tendencia',
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("info.calculateTrend")), 1),
            _hoisted_9,
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("info.upwardTrend")), 1),
            _hoisted_10,
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("info.downwardTrend")), 1),
            _hoisted_11,
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("info.flatTrend")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}